export default "__VITE_ASSET__D0e54WB9__"